import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueApexCharts from 'vue-apexcharts'
import VueHtml2Canvas from 'vue-html2canvas'
import firebase from 'firebase'
import { environment, firebaseConfig } from './config'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.config.productionTip = false

Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

Vue.use(VueHtml2Canvas)

let app = ''

firebase.initializeApp(firebaseConfig)

if (!environment.isProd) {
  // firebase.functions().useFunctionsEmulator('http://localhost:5001')
}

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount('#app')
  }
})
